import { render } from "./projectList.vue?vue&type=template&id=86adafd6"
import script from "./projectList.vue?vue&type=script&lang=js"
export * from "./projectList.vue?vue&type=script&lang=js"

import "../../../less/_projects_popup.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__